import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Setter, Store } from "../utils/storage";
import { getQuery } from "../utils/api";

const storage = Store("session");

const State = {
  parking: [],
  parkingMeters: [],
  parkingStructures: [],
  loadingParking: false,
  showMeter: true,
  showStructure: true,
};

const toggleParking = (parkingMeters, parkingStructures, showMeter, showStructure, set) => {
  let parkingList = [];

  if (showMeter && showStructure) {
    parkingList = [...parkingMeters, ...parkingStructures];
  } else if (showMeter && !showStructure) {
    parkingList = parkingMeters;
  } else if (!showMeter && showStructure) {
    parkingList = parkingStructures;
  }

  set({
    parking: parkingList.sort((a, b) => a.name.localeCompare(b.name)),
    showMeter,
    showStructure,
  });
};

const Actions = (_set, get) => {
  const set = Setter(_set);
  const URL = process.env.REACT_APP_PARKING_ENDPOINT;

  const fetchParking = async () => {
    const { showMeter, showStructure } = get();
    set({ loadingParking: true });

    const response = await getQuery(URL);

    if (response.response === 200) {
      const parkingData = response.data.parkingLocations || [];
      const parkingMeters = parkingData.filter((p) => p.type === "meter");
      const parkingStructures = parkingData.filter((p) => p.type === "structure");
      const parking = [...(showMeter ? parkingMeters : []), ...(showStructure ? parkingStructures : [])];
      set({
        parking,
        parkingMeters,
        parkingStructures,
        loadingParking: false,
      });
    } else {
      console.error("Error fetching parking:", response.error || response);
      set({ parking: [], loadingParking: false });
    }
  };

  const toggleMeter = () => {
    const { parkingMeters, parkingStructures, showMeter, showStructure } = get();
    let otherToggle = showStructure;
    if (showMeter && !otherToggle) {
      otherToggle = true;
    }
    toggleParking(parkingMeters, parkingStructures, !showMeter, otherToggle, set);
  };

  const toggleStructure = () => {
    const { parkingMeters, parkingStructures, showMeter, showStructure } = get();
    let otherToggle = showMeter;
    if (!showMeter && showStructure) {
      otherToggle = true;
    }
    toggleParking(parkingMeters, parkingStructures, otherToggle, !showStructure, set);
  };

  return {
    fetchParking,
    toggleMeter,
    toggleStructure,
  };
};

const ParkingStore = create(
  persist(
    (set, get) => {
      const actions = Actions(set, get);
      return {
        ...State,
        fetchParking: actions.fetchParking,
        toggleMeter: actions.toggleMeter,
        toggleStructure: actions.toggleStructure,
      };
    },
    {
      name: "app.parking",
      storage: createJSONStorage(() => storage),
    }
  )
);

export default ParkingStore;
